import React, { lazy } from 'react';

const GapCoverageComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-gap-coverage" */ './gap-coverage')
);

export const GapRoute = () => {
  return <GapCoverageComponent />;
};
